import { getImageURL } from "../../services/ImageService";

export function SectionCardVStack(props) {
    const backgroundImagePath = props.img ? getImageURL(props.img) : null;

    return (
        <div
            className={`z-30 flex flex-col gap-8 md:gap-4 col-span-full md:col-span-1 ${
                props.className ? props.className : ""
            }`}
        >
            {props.img && (
                <div
                    className="rounded-4xl bg-center bg-cover h-[24rem]"
                    style={{ backgroundImage: backgroundImagePath }}
                />
            )}
            <div className="w-full">
                <h3 className="mt-0 font-robotoCondensed leading-[1.2] font-semibold">
                    {props.title}
                </h3>
                <p className="text-lg font-regular">{props.text}</p>
            </div>
            {props.children && <div className="w-full">{props.children}</div>}
        </div>
    );
}
